/**
 * Scale DataGrid column widths for narrow viewports.
 * Preserves flex columns; floors pixel widths so actions/status stay usable.
 */
export function scaleColumnsForMobile(columns, { scale = 0.55, minWidth = 72, maxScaleWidth = 160 } = {}) {
  if (!Array.isArray(columns)) return columns;
  return columns.map((col) => {
    if (!col || col.flex != null) return col;
    const next = { ...col };
    if (typeof next.width === 'number') {
      next.width = Math.max(minWidth, Math.min(maxScaleWidth, Math.round(next.width * scale)));
    }
    if (typeof next.minWidth === 'number') {
      next.minWidth = Math.max(minWidth, Math.round(next.minWidth * scale));
    }
    return next;
  });
}
